__turbopack_context__.v({
  "arrow": "EPtDeq_arrow",
  "floating": "EPtDeq_floating",
  "reference": "EPtDeq_reference",
  "referenceFallback": "EPtDeq_referenceFallback",
});
